import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppstorageTsService } from '../appstorage/appstorage.ts.service';
import { checkRedirectLoggedInRoutesName, checkRedirectLoggedOutRoutesName } from '../routing/factory';
import { ConfigService } from '../config/config.service';
import { ControlHelperService } from '../control/control-helper.service';
import { ControlService } from '../control/control.service';
import { EventsService } from '../event/event.service';
import { GameHubControllerService } from '../gameHub/game-hub-controller';
import { GameTileService } from '../game-tile/game-tile.service';
import { LogoutService } from '../logout/logout.service';
import { RoutingService } from '../routing/routing.service';
import { StructureService } from '../structure/structure.service';
import { UserSessionService } from '../user-session/user-session.service';
import { UtilsService } from '../utils/utils.service';
import { WebcontentService } from '../webcontent/webcontent.service';
import { Navigator } from '../routing/navigator';
import { CategoryInterface, SubCategoryInterface } from 'src/app/interfaces/lobby.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})

export class RedirectService {

  public href: string = "";
  public categories: CategoryInterface[] = []

  constructor(
    private appStorageService: AppstorageTsService,
    private config: ConfigService,
    private control: ControlService,
    private controlHelper: ControlHelperService,
    private events: EventsService,
    private gameHubControllerService: GameHubControllerService,
    private gameTile: GameTileService,
    private logoutService: LogoutService,
    private navigator: Navigator,
    private router: Router,
    private routing: RoutingService,
    private structure: StructureService,
    private utilsService: UtilsService,
    private webcontentService: WebcontentService,
  ) { }

  public checkForRedirects(): any {
    let url = document.location.href;

    if (url.indexOf('#paypal') > -1) {
      this.events.publish("event:lobby:hide");
      this.events.publish("event:notification:suspend");
      return this.navigator.navigateTo("DepositPaypalComponent", {}, { paypalResult: parent.window.location.search.slice(1), paypalHashValue: url });
    }

    if (url.indexOf('#interac-return') > -1) {
      this.events.publish("event:lobby:hide");
      this.events.publish("event:notification:suspend");
      return this.navigator.navigateTo("DepositInteracActionPage", {}, { interacReturn: url });
    }

    if (url.indexOf('#password_reset') > -1 || url.indexOf('#password_forgot') > -1) {
      this.events.publish("event:lobby:hide");
      let twoFactor = this.config.getConfig().FEATURE_MFA_ON_EMAIL ?? 0;

      if (twoFactor == 1 || twoFactor == "1") {
        return this.navigator.navigateTo("ResetPassword2FAComponent", {}, { tokenURL: url });
      } else {
        return this.navigator.navigateTo("ResetPassword2FAComponent", {}, { tokenURL: url });
      }
    }
    if (url.indexOf('#game_launch') > -1) {
      this.gameLaunch(url);
    }
    if (url.indexOf('#upload_customer_documents') > -1) {
      this.events.publish("event:lobby:hide");
      return this.navigator.navigateTo("SecureUplodDocumentComponent", {}, {tokenURL: url});
   }
  }

  public gameLaunch(url) {
    const authCheckForUser = !!localStorage.getItem('userSession.sessionToken');

    const pathValue = this.extractPathValue(url);
    const gameObject = { id: null, game_name: null };

    if (pathValue) {
      const [id, game_name] = pathValue.split('/');
      gameObject.id = id;
      gameObject.game_name = game_name;
      if (authCheckForUser) {
        setTimeout(() => {
          return this.gameHubControllerService.launchCasinoGame(gameObject);
        }, 2000);
      } else {
        this.gameTile.waitingGameData = gameObject;
        return this.navigator.navigateTo("LoginComponent");
      }
    }
  }

  public extractPathValue(url) {
    // Check if the URL contains the fragment '#game_launch'
    const fragmentIndex = url.indexOf('#game_launch');
    if (fragmentIndex !== -1) {
      let pathStartIndex = fragmentIndex + '#game_launch'.length + 1;
      let pathValue = url.substring(pathStartIndex);
      pathValue = decodeURIComponent(pathValue);
      return pathValue;
    }
    return null;
  }

  public navigateBasedOnPathName(): any {
    let pageName = window.location.pathname;

    //Adding Special Check to consume quereyparams case ---START---
     const checkQueryParams = parent.window.location.search.slice(1);
    if (checkQueryParams) {
      let urlParts = pageName.split("/");
      const stub = urlParts[1];
      if (stub == 'article' && typeof urlParts[2] === 'string') {
        return this.webcontentService.updateWebcontentLink(urlParts[2]);
      }
      return;
    }
    //Adding Special Check to consume quereyparams case ---END---

    if (pageName && pageName.indexOf('localhost') > -1) {
      pageName = '/';
    }

    if (!!pageName && pageName != "/" && !~pageName.indexOf('index.html')) {
      pageName = this.utilsService.cleanPathName(pageName);
    }

    let urlParts = pageName.split("/");
    const stub = urlParts[0];

    return this.actionsBasedonStub(stub, typeof urlParts[1], urlParts[1]);

  }

    private async actionsBasedonStub(stub: string, part: any, partValue?: any): Promise<void> {
    await this.fetchLobbyCategory()
    const matched = this.categories
      .filter((cat: CategoryInterface) => !!cat.category_route)
      .find((cat: CategoryInterface) => cat.category_route === partValue) ||
      this.categories.map((cat: CategoryInterface) =>
        Array.isArray(cat.subCategories) ? cat.subCategories : []
      ).reduce((acc, val) => acc.concat(val), []).find((subCat: SubCategoryInterface) => subCat.category_route === partValue);

    // if (matched) {
    //   console.log('Matched route category:', matched);
    // } else {

    //   console.warn('No matching category_route found.');
    // }

    if (stub == 'article' && part === 'string') stub = 'webviewStub';
    if (stub == 'casino' && part === 'string') stub = 'casinostub';
    if (stub == 'lobby' && part === 'string') stub = 'lobbystub';
    if (stub == 'promotions') stub = 'promotionstub';

    switch (stub) {
      case 'launcher':
        this.control.goToDefaultCategory();
        break;
      case 'webviewStub':
        if (matched) {
          setTimeout(() => {
            document.getElementsByClassName("active")[0]?.scrollIntoView({ behavior: 'smooth', inline: "center" });
          }, 200);
          this.controlHelper.setActiveLobbyCategory(matched);
          return this.control.selectCategory(matched);
        }
        this.control.setCategoryForWordPressPage();
        this.webcontentService.updateWebcontentLink(partValue);
        this.eventPublisher("event:reload:externallinks");
        this.routing.toWebviewTab(false, partValue);

        break;
      case 'casinostub':
        if (matched) setTimeout(() => {
          document.getElementsByClassName("active")[0]?.scrollIntoView({ behavior: 'smooth', inline: "center" });
        }, 200);
        this.control.selectCategory(matched);
        this.controlHelper.setActiveLobbyCategory(matched);
        break;
      case 'lobbystub':
        this.routing.toLobbyTab();
        break;
      case 'promotionstub':
        this.control.setPromotionPage();
        break;
      default:
        this.browserReloadModalComponentAction(stub, part, partValue);
        break;
    }
  }

   public browserReloadModalComponentAction(stub: string, part: any, partValue?: any) {
    //All modal component logic based on user authentication
    //Below logic includes redirect on page refresh
    let authCheckForUser: boolean;
    if (localStorage.getItem('userSession.sessionToken') !== null) {
      authCheckForUser = true;
    } else {
      authCheckForUser = false;
    }
    if (stub != "/") {
      let pageToLoad;
      //Special Check for WP Pages to accomodate new authentication related check
      if (stub == 'webview' && typeof part === 'string') {
        this.webcontentService.updateWebcontentLink(partValue);
        this.eventPublisher("event:reload:externallinks");
        return this.routing.toWebviewTab(false, partValue);
      }

      if (authCheckForUser) {
        pageToLoad = checkRedirectLoggedInRoutesName(stub);
        if (!!pageToLoad) {
          this.routing.defaultRoute();
          return this.navigator.navigateTo(pageToLoad);
        }
        return this.router.navigate(['/lobby'], { skipLocationChange: false });
      } else {
        pageToLoad = checkRedirectLoggedOutRoutesName(stub);
        if (!!pageToLoad) {
          this.routing.defaultRoute();
          return this.navigator.navigateTo(pageToLoad);
        }
        return this.control.goToDefaultCategory();
      }
    } else {
      this.control.goToDefaultCategory();
    }
  }

  public mobileRedirectBasedOnPathName() {
    let pageName = window.location.pathname;
    if (pageName == '/launcher') return this.routing.toLobbyTab();
  }

  public browserReloadActions(tabName): void {

    switch (tabName) {
      default:
        this.checkForRedirects();
        this.navigateBasedOnPathName();
        break;
    }
  }

  public getTabNames(tabName): boolean {
    const Tabs: any = {
      "livedealer": "livedealer"
    }

    if (tabName in Tabs) return true; //Tabs[tabName]
    return false;
  }

  //AppsFlyer DeepLink for Mobile Apps
  checkUserStateSelector(deepLinkPath: any, deepLinkStateName: any) {
    this.appStorageService.getJurisdiction().then((stardustJurisdictionResponse) => {
      const stardustJurisdiction = !!stardustJurisdictionResponse.value
        ? stardustJurisdictionResponse.value
        : "none";
      //If deep_link_sub1 which is deepLinkStateName param is not set
      //than set the user preference for state and then load the deeplink path
      if (stardustJurisdiction == 'none') {
        console.log(deepLinkPath)
        console.log(deepLinkStateName)
        const deepLinkSub1: any = deepLinkStateName ? deepLinkStateName : "NJ";
        this.appStorageService.setJurisdiction(deepLinkSub1).then(() => {
          this.config.reloadConfig().then(() => {
            return setTimeout(() => {
              console.log("skin: jurisdiction change ", deepLinkSub1);
              this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);
            }, 1000);
          });
        });
      } else {
        //If deep_link_sub1 which is deepLinkStateName param is different
        //value than user has already state selected then update the preference logic

        if (stardustJurisdiction == deepLinkStateName) {
          this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);
        } else {
          setTimeout(() => {
            let selectedStateName;
            //deepLinkStateName is empty after venmo payment, then set the Jurisdiction from storage.
            if (deepLinkStateName) {
              selectedStateName = deepLinkStateName;
            } else {
              selectedStateName = stardustJurisdiction;
            }
            this.appStorageService.setJurisdiction(selectedStateName).then(() => {
              this.config.reloadConfig().then(() => {
                return setTimeout(() => {
                  console.log("skin: jurisdiction change ", selectedStateName);
                  this.deepLinkActionForAppsFlyer(deepLinkPath, selectedStateName);
                }, 1000);
              });
            });
          }, 1000); //Added Timeout to finish the app's default re-directing to selected state
        }
        //If use has alreday state selector preference then
        //ignore deep_link_sub1 which is deepLinkStateName param value
        //this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);
      }
    })
  }

  //AppsFlyer DeepLink for Mobile Apps
  public deepLinkActionForAppsFlyer(pageName, stateName?): any {

    if (!!pageName && pageName != "/" && !~pageName.indexOf('index.html')) {
      pageName = this.utilsService.cleanPathName(pageName);
    }
    let urlParts = pageName.split("/");
    const stub = urlParts[0];
    console.log(urlParts)

    //Login componenet Redirect Logic
    if (stub == 'login') {
      this.routing.toLobbyTab();
      return this.navigator.navigateTo('LoginComponent');
    };

    //Signup componenet Redirect Logic
    if (stub == 'signup' || stub == 'join') {
      // let pageName = 'SignupOptionsComponent';
      // if(stateName == "ON") {
      //   pageName = 'SignupStepOneComponent';
      // }
      let pageName = 'SignupStepOneComponent';
      this.routing.toLobbyTab();
      return this.navigator.navigateTo(pageName);
    };

    //game info page redirect logic
    if (stub == 'game' && typeof urlParts[1] === 'string') {
      this.webcontentService.updateExternalLink(urlParts[1]);
      //required timeout bigger number than what is set in the site location service to redirect user to lobby after showing splash page
      return setTimeout(() => {
        this.routing.toWebviewTab();
        this.navigator.pushHistoryState("game/" + urlParts[1])
      }, 1500);
    };

    //webview page redirect logic
    if (stub == 'c' && typeof urlParts[1] === 'string') {
      this.webcontentService.updateExternalLink(urlParts[1]);
      //required timeout bigger number than what is set in the site location service to redirect user to lobby after showing splash page
      return setTimeout(() => {
        this.routing.toWebviewTab();
        this.navigator.pushHistoryState("c/" + urlParts[1])
      }, 1500);
    }

    //sports page redirect logic - future request

  }

   private eventPublisher(str: string): void {
    this.events.publish(str);
  }

  async fetchLobbyCategory(): Promise<void> {
    this.categories = await new Promise<CategoryInterface[]>((resolve) => {
      this.structure.getCategoriesByPlacement('MAIN')
        .pipe(
          filter(catList => catList?.length > 0),
          untilDestroyed(this))
        .subscribe(resolve);
    });
  }

}
